module.exports = __webpack_public_path__ + "354445ff88b38e75aa74e367e3900dc8.png";


//////////////////
// WEBPACK FOOTER
// ./public/pic1@2x.png
// module id = 208
// module chunks = 1